import SearchResults from './SearchResults';

export default function SearchNewsArticle() {
  return <SearchResults categoryId={8} />;
}
